/*
 reportsRepo

 This class will fetch and store data from the database.

 */

import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import moment from 'moment';
import { dashboard } from '../dashboards/dashboard';
import { authService } from '../login';

var ReportsRepo = (function () {
	var lastRequest;
	var lastRequestTime;

	var _allInsightColumns = null; //cache of all Insight columns
	var _breakdownColumns = null; //cache of breakdown columns
	var _listValueColumns = null; //cache of list value columns

	function reportsRepo() {

	}

	reportsRepo.prototype.moveReport = function () {
		var deferred = $.Deferred();

		$.ajax({
			url: `${API_URL}/reports/getdefaultreportid`,
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (results, status, jqXhr) {
				deferred.resolve(results);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};
	reportsRepo.prototype.checkRollupStatus = function () {
		var deferred = $.Deferred();

		$.ajax({
			url: `${API_URL}/rollupstatus`,
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (results, status, jqXhr) {
				deferred.resolve(results);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};
	reportsRepo.prototype.getDefaultReportId = function () {
		var deferred = $.Deferred();

		$.ajax({
			url: `${API_URL}/reports/getdefaultreportid`,
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (results, status, jqXhr) {
				deferred.resolve(results);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	reportsRepo.prototype.setDefaultReportId = function (reportId) {
		var deferred = $.Deferred();

		$.ajax({
			url: `${API_URL}/reports/SetUserDefaultReport?reportid=` + reportId,
			type: 'POST',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (results, status, jqXhr) {
				deferred.resolve(results);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	reportsRepo.prototype.getReportContent = function (args) {

		var deferred = $.Deferred();

		var reportId = args.reportId || -1;
		var dashboardId = args.dashboardId || -1;
		var widgetId = args.widgetId || -1;
		var topCount = args.topCount || 10;
		var sortField = args.sortField || "";
		var sortDescending = args.sortDescending || false;

		var postData = {};
		postData.sortField = sortField;
		postData.sortDirection = sortDescending ? "desc" : "";
		postData.topRows = topCount;
		postData.skipRows = 0;
		postData.dashboardGroupBy = args.dashboardGroupBy;

		$.ajax({
			url: `${API_URL}/reportcontent?reportId={0}&dashboardId={1}&widgetId={2}`.format(reportId, dashboardId, widgetId),
			type: 'POST',
			data: postData,
			processData: true,
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (results) {
				deferred.resolve(results);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	reportsRepo.prototype.getReport = function (reportId) {
		var deferred = $.Deferred();

		$.ajax({
			url: `${API_URL}/reports/getreportbyid?reportId={0}`.format(reportId),
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (results, status, jqXhr) {
				deferred.resolve(results);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	reportsRepo.prototype.getReportDates = function (dateRange, trendType) {
		var deferred = $.Deferred();

		$.ajax({
			url: `${API_URL}/reports/getreportdates?daterange={0}&trendtype={1}`.format(dateRange, trendType),
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (results, status, jqXhr) {
				deferred.resolve(results);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	reportsRepo.prototype.getMaxReportDate = function () {
		var deferred = $.Deferred();

		$.ajax({
			url: `${API_URL}/reports/getmaxreportdate`,
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (results, status, jqXhr) {
				deferred.resolve(results);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	reportsRepo.prototype.addReportToFavorites = function (reportId) {
		var deferred = $.Deferred();

		$.ajax({
			url: `${API_URL}/reports/addreporttofavorites?reportId={0}`.format(reportId),
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (results, status, jqXhr) {
				deferred.resolve(results);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	reportsRepo.prototype.removeReportFromFavorites = function (reportId) {
		var deferred = $.Deferred();

		$.ajax({
			url: `${API_URL}/reports/removereportfromfavorites?reportId={0}`.format(reportId),
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (results, status, jqXhr) {
				deferred.resolve(results);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	reportsRepo.prototype.getReportFull = function (reportId) {
		var deferred = $.Deferred();

		$.when(
			reportsRepo.prototype.getReport(reportId),
			reportsRepo.prototype.getReportColumns(reportId),
			reportsRepo.prototype.getReportFilters(reportId)).then(
				function (reportResult, columns, filters) {

					if (reportResult) {
						reportResult.columns = _.defaultIfNullOrUndefined(columns, []);
						reportResult.filters = _.defaultIfNullOrUndefined(filters, {});
					}

					deferred.resolve(reportResult);
				},
				function (xhr) {
					deferred.reject(xhr);
				}
			);

		return deferred.promise();
	};

	reportsRepo.prototype.getAllReportShareObjects = function () {

		var deferred = $.Deferred();

		$.ajax({
			url: `${API_URL}/reportsharedata/getallshareobjects`,
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (result, status, jqXhr) {
				deferred.resolve(result);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	reportsRepo.prototype.getReportShareData = function (reportId) {
		var deferred = $.Deferred();

		$.ajax({
			url: `${API_URL}/reportsharedata/get?reportId={0}`.format(reportId),
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (result, status, jqXhr) {

				deferred.resolve(result);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	reportsRepo.prototype.saveReportShareData = function (shareData) {
		var deferred = $.Deferred();

		var jsonDataString = JSON.stringify(shareData);

		$.ajax({
			url: `${API_URL}/reportsharedata/save`,
			type: 'POST',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			data: jsonDataString,
			processData: false,
			contentType: 'application/json; charset=utf-8',
			dataType: 'json',
			success: function (result) {
				deferred.resolve(result);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	reportsRepo.prototype.deleteReport = function (reportId) {
		var deferred = $.Deferred();

		$.ajax({
			url: `${API_URL}/reports/deletereport?reportId={0}`.format(reportId),
			type: 'POST',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			processData: false,
			contentType: 'application/json; charset=utf-8',
			dataType: 'json',
			success: function (result) {
				deferred.resolve(result);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	//Get all reports
	reportsRepo.prototype.getAllReports = function () {
		var deferred = $.Deferred();

		$.ajax({
			url: `${API_URL}/reports/getall`,
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (results, status, jqXhr) {

				var reports = _.mapCamelCase(results);
				deferred.resolve(reports);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	//Get all report folders
	reportsRepo.prototype.getReportFolders = function () {

		var deferred = $.Deferred();

		$.ajax({
			url: `${API_URL}/reportfolders`,
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (results) {

				var folders = _.mapCamelCase(results);
				deferred.resolve(folders);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	//Get fiscal date data
	reportsRepo.prototype.getFiscalDateData = function () {

		var deferred = $.Deferred();

		$.ajax({
			url: `${API_URL}/insightcalendar/getfiscaldatedata?fiscaldate=` + moment().format("MM-DD-YYYY"),
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (result) {
				deferred.resolve(result);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	//Get all fiscal periods of a certain type
	reportsRepo.prototype.getAllFiscalPeriods = function (periodType, startingFiscalYear, startingFiscalPeriod) {

		var deferred = $.Deferred();

		startingFiscalYear = startingFiscalYear ? startingFiscalYear : "";
		startingFiscalPeriod = startingFiscalPeriod ? startingFiscalPeriod : "";

		$.ajax({
			url: `${API_URL}/insightcalendar/getallperiods?periodtype=` + periodType + "&startingfiscalyear=" + startingFiscalYear + "&startingfiscalperiod=" + startingFiscalPeriod,
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (results) {
				deferred.resolve(results);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	//Move report to the specified folder
	reportsRepo.prototype.moveReportToFolder = function (reportId, oldFolderName, newFolderName) {

		var deferred = $.Deferred();

		$.ajax({
			url: `${API_URL}/reports/movereporttofolder?reportid=` + reportId + "&oldfoldername=" + oldFolderName + "&newfoldername=" + newFolderName,
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (results) {
				deferred.resolve(results);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	//Copy report to the specified folder
	reportsRepo.prototype.copyReportToFolder = function (reportId, folderName) {

		var deferred = $.Deferred();

		$.ajax({
			url: `${API_URL}/reports/copyreporttofolder?reportid=` + reportId + "&foldername=" + folderName,
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (results) {
				deferred.resolve(results);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	//Remove report the specified folder
	reportsRepo.prototype.removeReportFromFolder = function (reportId, folderName) {

		var deferred = $.Deferred();

		$.ajax({
			url: `${API_URL}/reports/removereportfromfolder?reportid=` + reportId + "&foldername=" + folderName,
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (results) {
				deferred.resolve(results);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	//Add a new report folder
	reportsRepo.prototype.addNewReportFolder = function (reportId, folderName) {

		var deferred = $.Deferred();

		$.ajax({
			url: `${API_URL}/reportfolders/save?reportid=` + reportId + "&foldername=" + folderName,
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (results) {
				deferred.resolve(results);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	//Get report filters for specified report id
	reportsRepo.prototype.getReportFilters = function (reportId) {
		var deferred = $.Deferred();

		var dataUrl = `${API_URL}/reportfilters/getreportfilters?reportid={0}`.format(reportId);

		$.ajax({
			url: dataUrl,
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (results) {
				deferred.resolve(results);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	//Get report columns for specified report id
	reportsRepo.prototype.getReportColumns = function (reportId) {
		var deferred = $.Deferred();

		var dataUrl = `${API_URL}/reportcolumns/getbyreportid?reportid={0}`.format(reportId);

		$.ajax({
			url: dataUrl,
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (results) {

				var columns = [];

				_.forEach(results,
					function (col, index) {
						var newColumn = {};

						//kendo specific properties
						newColumn.field = col.propertyName;
						newColumn.title = col.caption;
						newColumn.width = _.defaultIfNullOrUndefined(col.columnWidth, 100);
						newColumn.format = col.displayFormat;
						newColumn.filterable = true;

						//Other properties
						newColumn.allowReportTransition = col.allowReportTransition;
						newColumn.widthOriginal = _.defaultIfNullOrUndefined(col.columnWidth, 100);
						newColumn.reportId = col.reportId;
						newColumn.columnId = col.columnId;
						newColumn.propertyName = col.propertyName;
						newColumn.caption = col.caption;
						newColumn.columnOrder = index;
						newColumn.dataTypeString = col.dataTypeString;
						newColumn.columnTypeString = col.columnTypeString;
						newColumn.trendIndex = _.defaultIfNullOrUndefined(col.trendIndex, 0);
						newColumn.showTrend = col.showTrend;
						newColumn.id = col.id;

						//Update the column attributes
						reportsRepo.prototype.updateReportColumnAttributes(newColumn);

						columns.push(newColumn);
					});

				deferred.resolve(columns);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	reportsRepo.prototype.updateColumnWidth = function (id, newWidth) {
		var deferred = $.Deferred();

		var dataUrl = `${API_URL}/reportcolumns/resizecolumn?pkcolumnid={0}&newwidth={1}`.format(id, newWidth);

		$.ajax({
			url: dataUrl,
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function () {
				deferred.resolve(true);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	//Get breakdown columns
	reportsRepo.prototype.getBreakdownColumns = function () {
		var deferred = $.Deferred();

		//If breakdown columns are already cached, just return the cached results
		if (!_.isNullOrUndefined(_breakdownColumns)) {
			deferred.resolve(_breakdownColumns);
			return deferred.promise();
		}

		var dataUrl = `${API_URL}/insightbreakdowncolumns`;

		$.ajax({
			url: dataUrl,
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (breakdownCols) {

				var results = [];

				_.forEach(breakdownCols, function (breakdownCol) {

					var newCategory = {};
					newCategory.text = breakdownCol.category;
					newCategory.items = [];

					_.forEach(breakdownCol.columns, function (col) {

						var newColumn = {};

						newColumn.field = col.propertyName;

						//Other properties
						newColumn.allowReportTransition = col.allowReportTransition;
						newColumn.columnId = col.columnId;
						newColumn.propertyName = col.propertyName;
						newColumn.caption = col.caption;
						newColumn.dataTypeString = col.dataTypeString;
						newColumn.groupByFieldName = col.groupByFieldName;

						newCategory.items.push(newColumn);
					});

					results.push(newCategory);
				});

				//Cache the results;
				_breakdownColumns = results;

				deferred.resolve(results);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	//Get all report columns
	reportsRepo.prototype.getAllInsightColumns = function () {
		var deferred = $.Deferred();

		//If the columns are already cached, just return the cached results
		if (!_.isNullOrUndefined(_allInsightColumns)) {
			deferred.resolve(_allInsightColumns);
			return deferred.promise();
		}

		$.ajax({
			url: `${API_URL}/insightcolumns`,
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (results) {

				var columns = [];

				_.forEach(results,
					function (col, index) {
						var newColumn = {};

						//kendo specific properties
						newColumn.field = col.propertyName;
						newColumn.title = col.caption;
						newColumn.width = _.defaultIfNullOrUndefined(col.columnWidth, 100);
						newColumn.format = col.displayFormat;
						newColumn.filterable = true;

						//Other properties
						newColumn.allowReportTransition = col.allowReportTransition;
						newColumn.widthOriginal = _.defaultIfNullOrUndefined(col.columnWidth, 100);
						newColumn.columnId = col.columnId;
						newColumn.propertyName = col.propertyName;
						newColumn.caption = col.caption;
						newColumn.dataTypeString = col.dataTypeString;

						columns.push(newColumn);
					});

				columns = _.sortBy(columns, function (c) { return c.caption; });

				//Cache the results
				_allInsightColumns = columns;

				deferred.resolve(columns);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	//Get all report columns
	reportsRepo.prototype.getListOfValuesColumns = function () {
		var deferred = $.Deferred();

		//If the columns are already cached, just return the cached results
		if (!_.isNullOrUndefined(_listValueColumns)) {
			deferred.resolve(_listValueColumns);
			return deferred.promise();
		}

		$.ajax({
			url: `${API_URL}/listofvalues/getlistofvaluescolumns`,
			type: 'GET',
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (results) {

				//Cache the results
				_listValueColumns = results;

				deferred.resolve(results);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	//Save report
	reportsRepo.prototype.saveReportAsNew = async function (report) {
		//Delete properties that will mess up our api call.
		delete report.columns;
		delete report.reportOwners;

		var jsonDataString = JSON.stringify(report);

		const response = await fetch(`${API_URL}/reports/saveasnew`, {
			body: jsonDataString,
			headers: {
				'Authorization': authService.getAuthorizationHeaderValue(),
				'Content-Type': 'application/json; charset=utf-8'
			},
			method: 'POST',
		});

		authService.handleApiResult(response);

		return response;
	};

	//Update report
	reportsRepo.prototype.updateReportFull = async function (report, columns) {
		//Delete properties that will mess up our api call.
		delete report.columns;
		delete report.reportOwners;

		var columnOrder = 1;
		_.forEach(columns, function (col) {
			col.reportId = report.reportId;
			col.columnOrder = columnOrder++;
			col.columnWidth = _.defaultIfNullOrUndefined(col.width, col.widthOriginal);
		});

		var jsonObject = {};
		jsonObject.report = report;
		jsonObject.columns = columns;

		var jsonDataString = JSON.stringify(jsonObject);

		const response = await fetch(`${API_URL}/reports/updatereportfull`, {
			body: jsonDataString,
			headers: {
				Authorization: authService.getAuthorizationHeaderValue(),
				'Content-Type': 'application/json; charset=utf-8'
			},
			method: 'POST',
		});

		authService.handleApiResult(response);

		return response;
	};

	//Save report filters
	reportsRepo.prototype.saveReportFilters = async function (reportId, filters) {
		var jsonDataString = ko.toJSON(filters);

		const response = await fetch(
			`${API_URL}/reportfilters/savereportfilters?reportId={0}&overridefilters={1}`.format(reportId, filters ? "true" : "false"),
			{
				body: jsonDataString,
				headers: {
					Authorization: authService.getAuthorizationHeaderValue(),
					'Content-Type': 'application/json; charset=utf-8'
				},
				method: 'POST'
			}
		);

		authService.handleApiResult(response);

		return response;
	};

	//Update attributes on the report column object
	reportsRepo.prototype.updateReportColumnAttributes = function (column) {

		//Add class attributes that will show up in the DOM
		column.attributes = {};
		column.attributes.class = "";

		//Numeric columns should have text-right class
		if (column.format === 'p2' || column.format === 'n2' || column.format === 'c2' || column.format === 'n0') {
			column.attributes.class = column.attributes.class.length === 0 ? "text-right" : " text-right";
		}
	};

	reportsRepo.prototype.exportToExcel = function (reportId, postData, breakdown) {

		var deferred = $.Deferred();

		$.ajax({
			type: "POST",
			url: `${API_URL}/reportcontent?reportid=` + reportId + "&breakdowngroupby=" + breakdown + "&excelexport=true",
			data: postData,
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (response, status, request) {

				window.location = `${API_URL}/reportcontent/export?filename=` + response;
				deferred.resolve(status);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	reportsRepo.prototype.emailReport = function (to, subject, body) {

		var deferred = $.Deferred();

		var postObj = {};
		postObj.to = to;
		postObj.subject = subject;
		postObj.from = 'no_reply@trackmax.com';
		postObj.body = body;

		$.ajax({
			type: "POST",
			url: `${API_URL}/Email`,
			data: postObj,
			processData: true,
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
			},
			success: function (response, status, request) {

				deferred.resolve(status);
			},
			error: function (jqXhr, status, error) {
				authService.handleApiResult(jqXhr);
				deferred.reject(jqXhr);
			}
		});

		return deferred.promise();
	};

	return reportsRepo;
})();

export const reportsRepo = new ReportsRepo();
